import { createStyles, Theme } from '@material-ui/core/styles';
import type { TableProps } from './Table';

const styles = ({
  colors, spacing, flags, typography,
}: Theme) => createStyles({
  root: {
    width: '100%',
  },
  tableContainer: {
    position: 'relative',
    border: flags.boxStyle === 'stroke' ? 'none' : `1px solid ${colors.pageElements.table.border}`,
    borderRadius: colors.pageElements.table.corner,
    overflow: 'hidden',
  },
  table: {
    minWidth: spacing(125),
    tableLayout: 'fixed',
    borderCollapse: 'initial',
  },
  tableWithPlaceholder: {
    borderBottom: 'none',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  placeholder: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: spacing(6),
    paddingBottom: spacing(6),
    border: flags.boxStyle === 'stroke' ? 'none' : `1px solid ${colors.pageElements.table.border}`,
    borderRadius: spacing(1),
    borderTop: 'none',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  placeholderInline: {
    paddingBottom: spacing(3),
    paddingTop: spacing(2),
    alignItems: 'start',
    border: 'none',
  },
  placeholderText: (props: TableProps) => ({
    color: colors.text.secondary,
    marginTop: spacing(1),
    width: 'max-content',
    ...(props.emptyPlaceholderInline ? {
      display: 'inline-block',
    } : {}),
  }),
  placeholderCell: {
    height: '34px',
    position: 'relative',
    padding: '0 1px',
  },
  placeholderCellText: {
    position: 'absolute',
    width: spacing(50),
    paddingLeft: spacing(10),
  },
  cell: {
    ...typography.textBig,
    color: colors.text.primary,
    wordBreak: 'break-word',
    verticalAlign: 'top',
    padding: `${spacing(3)}px ${spacing(2)}px`,
    borderBottomColor: colors.pageElements.table.rowDivider,
    borderBottomStyle: 'solid',
    borderBottomWidth: flags.boxStyle === 'stroke' ? 2 : 1,
  },
  row: {
    '&:last-child $cell': {
      borderBottomColor: colors.pageElements.table.headerDivider,
      borderBottomWidth: flags.boxStyle === 'stroke' ? 2 : 0,
    },
  },
  cellLarge: {
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
  },
  paginationToolbar: {
    alignItems: 'baseline',
  },
  spacer: {
    flex: 0,
  },
  caption: {
    '&:nth-child(4)': {
      flex: 1,
    },
  },
  paginationCaption: {
    marginRight: spacing(4.5),
  },
  paginationSelectRoot: {
    ...typography.textSmall,
    width: spacing(15),
    height: spacing(6),
    border: `1px solid ${colors.pageElements.table.border}`,
    borderRadius: spacing(1),
    marginLeft: spacing(1),
    marginRight: spacing(6),
    '& svg': {
      fill: colors.text.primary,
    },
  },
  paginationSelect: {
    textAlign: 'left',
    textAlignLast: 'left',
    borderBottom: flags.boxStyle === 'stroke' ? `2px solid ${colors.text.primary}` : 'none',
  },
  paginationSelectMenu: {
    background: colors.layout.backgroundPrimary,
    '& li:hover': {
      background: `${colors.layout.backgroundSecondary} !important`,
    },
  },
  paginationRoot: {
    color: colors.text.primary,
    marginTop: spacing(3),
    '& .MuiIconButton-root.Mui-disabled': {
      color: colors.text.subtle,
    },
  },
});

export default styles;
